import React from "react";
import { TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

export const multilineStyles = () => ({
    cssOutlinedInput: {
        color: "var(--mainText) !important",
        '&$cssFocused $notchedOutline': {
            color: "var(--mainText) !important",
        }
    },
    cssFocused: {
        color: "var(--mainText) !important",
    },
    notchedOutline: {
        borderColor: 'var(--mainText) !important',
        color: "var(--mainText) !important",
    },
});

const TextFieldMultiline = (props) => {

    const {
        classes,
        autoFocus,
        ...rest
    } = props;

    return (
        <TextField
            autoFocus={autoFocus || false}
            multiline
            variant="outlined"
            InputLabelProps={{
                classes: {
                    focused: classes.cssFocused,
                },
            }}
            InputProps={{
                classes: {
                    root: classes.cssOutlinedInput,
                    focused: classes.cssFocused,
                    notchedOutline: classes.notchedOutline,
                }
            }}
            {...rest}
        />
    )
}

export default withStyles(multilineStyles)(TextFieldMultiline);